import { Star } from 'lucide-react';
import { RATING_LABEL, type PerformanceReview } from '@/client/types/hr';

export function Stars({ rating }: { rating?: number | null }) {
  if (!rating) return <span className="text-xs text-gray-400">No rating</span>;
  return (
    <span className="inline-flex items-center gap-0.5" title={RATING_LABEL[rating]}>
      {[1, 2, 3, 4, 5].map((n) => (
        <Star key={n} className={`h-3.5 w-3.5 ${n <= rating ? 'fill-amber-400 text-amber-400' : 'text-gray-300'}`} />
      ))}
    </span>
  );
}

/** A review's rating and written feedback, read-only. */
export function ReviewText({ review }: { review: PerformanceReview }) {
  return (
    <div className="space-y-2 text-sm">
      <div className="flex items-center gap-2">
        <Stars rating={review.rating} />
        {review.rating ? <span className="text-xs text-gray-500">{RATING_LABEL[review.rating]}</span> : null}
      </div>
      {review.strengths && (
        <div>
          <p className="text-xs font-medium text-gray-500">Strengths</p>
          <p className="whitespace-pre-wrap text-gray-800">{review.strengths}</p>
        </div>
      )}
      {review.improvements && (
        <div>
          <p className="text-xs font-medium text-gray-500">To work on</p>
          <p className="whitespace-pre-wrap text-gray-800">{review.improvements}</p>
        </div>
      )}
      {!review.strengths && !review.improvements && <p className="text-xs text-gray-400">Nothing written yet.</p>}
    </div>
  );
}
